/**
 * 타이머
 *
 * Usage.
 *  var myTimer = new Timer(3000, function() {
 *      console.log('Done');
 *  }, false);
 *
 * @param interval milliseconds number (required)
 * @param callback (required)
 * @param infinite true of false (option)
 * @constructor
 */
const Timer = function(interval, callback, infinite = false) {
    let id = 0;
    let startTime = 0;
    let pauseTime;

    let callbackWrapper = () => {
        callback();

        if (id && typeof infinite == 'boolean' && infinite) {
            restart();
        } else {
            this.stop();
        }
    }

    this.start = function() {
        if (!id) {
            startTime = new Date();
            id = setTimeout(callbackWrapper, interval);
        }
    }

    let restart = function() {
        startTime = new Date();
        id = setTimeout(callbackWrapper, interval);
    }

    this.stop = function() {
        if (id) clearTimeout(id);

        startTime = 0;
        id = 0;
    }

    this.pause = function() {
        pauseTime = new Date();
        clearTimeout(id);
    }

    this.resume = function() {
        let _interval = interval;

        if (!infinite) {
            _interval = pauseTime.getTime() - startTime.getTime();
        }

        startTime = new Date();
        id = setTimeout(callbackWrapper, _interval);
    }

    this.reset = function() {
        if (id) clearTimeout(id);

        startTime = new Date();
        id = setTimeout(callbackWrapper, interval);
    }

    // 남은 시간
    this.remainingTime = function() {
        if (startTime == 0) return 0;

        const now = new Date();
        return now.getTime() - startTime.getTime();
    }

}

export default Timer;